import { render, staticRenderFns } from "./PricingTableStatic.vue?vue&type=template&id=5117f58a&scoped=true&lang=pug&"
import script from "./PricingTableStatic.vue?vue&type=script&lang=js&"
export * from "./PricingTableStatic.vue?vue&type=script&lang=js&"
import style0 from "./PricingTableStatic.vue?vue&type=style&index=0&id=5117f58a&prod&lang=scss&scoped=true&"
import style1 from "./PricingTableStatic.vue?vue&type=style&index=1&id=5117f58a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5117f58a",
  null
  
)

export default component.exports